import React from 'react';
import { FaTag } from 'react-icons/fa';

const products = [
  {
    id: 127,
    title: 'Modern Glass Door Entrance',
    originalPrice: 50.00,
    salePrice: 35.00,
    imageUrl: 'images/shop-product10.jpg',
  },
  {
    id: 129,
    title: 'Innovative Glass Walkway',
    originalPrice: 40.00,
    salePrice: 30.00,
    imageUrl: '/images/1.jpg',
  },
  {
    id: 132,
    title: 'Elegant White French Door',
    originalPrice: 40.00,
    salePrice: 30.00,
    imageUrl: '/images/2.jpg',
  },
  {
    id: 134,
    title: 'Architectural Glass Ceiling',
    originalPrice: 40.00,
    salePrice: 30.00,
    imageUrl: '/images/3.jpg',
  },
];

const ProductSection = () => {
  const handleBuyNow = (productTitle) => {
    const phoneNumber = '+918793220265';
    const message = `I am interested in buying the product: ${productTitle}`;
    const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappLink, '_blank');
  };

  return (
    <section className="hm8paddingSection hm8ProductSection">
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-sm-10 col-xs-12 col-md-offset-2 col-sm-offset-1">
            <div className="home8Title">
              <h3>OUR SERVICES</h3>
              <h1>Your Trusted Partner for Custom Solutions</h1>
              <p>
                At Anjali Enterprises, we specialize in delivering a wide range of high-quality services tailored to meet your industrial and residential needs.
                From precision-crafted aluminium glass office partitions to robust toughened glass work and door partitions, we bring expertise and innovation to every project.
                Our offerings include ACP cladding panel installations, aluminium glass windows, and soundproof glass windows, ensuring functionality and elegance.
              </p>
            </div>
          </div>

          <div className="woocommerce columns-4">
            <ul className="products columns-4">
              {products.map((product) => (
                <li key={product.id} className="product-item product">
                  <a href="#" className="woocommerce-LoopProduct-link woocommerce-loop-product__link">
                    <img
                      width="268"
                      height="268"
                      src={product.imageUrl}
                      alt={product.title}
                      className="attachment-woocommerce_thumbnail size-woocommerce_thumbnail"
                    />
                    <h2 className="woocommerce-loop-product__title">{product.title}</h2>
                    <span className="price">
                      <del>
                        <span className="woocommerce-Price-amount amount"></span>
                      </del>
                      <ins>
                        <span className="woocommerce-Price-amount amount"></span>
                      </ins>
                    </span>
                  </a>
                  <button
                    className="button product_type_simple add_to_cart_button ajax_add_to_cart"
                    onClick={() => handleBuyNow(product.title)}
                    aria-label={`Add ${product.title} to your cart`}
                  >
                    BUY NOW
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductSection;
